// Put your application javascript here

// Navbar toggle logic
// Close desktop menu
function closeDesktopMenu(){
    document.getElementById('closeIcon').classList.add('hidden');
    document.getElementById('openIcon').classList.remove('hidden');

    console.log('menu closed');
    
    // Menu is open add class to it to trigger slide in transition
    document.getElementById('desktopMenu').classList.remove('desktop-open');

    document.getElementById('topNav').classList.remove('bg-[#282828]');
    document.getElementById('topNav').classList.add('hover:md:bg-[#282828]/50');

    // Update the icon logo color back to standard when the navigation is closed
    document.getElementById('dfLogo').classList.remove('logo-state-open');
    document.getElementById('dfLogo').classList.add('logo-state');

    //document.removeEventListener('click', closeMenuOnBodyClick);
}

// function closeMenuOnBodyClick(event){
      
//     // Menu is open add class to it to trigger slide in transition
//     document.getElementById('desktopMenu').classList.remove('desktop-open');

//     document.getElementById('testCloseIcon').classList.add('hidden');
//     document.getElementById('testOpenIcon').classList.remove('hidden');
// }

// Open desktop menu
function openDesktopMenu(){

    console.log('menu open');

    // Menu is currently closed
    document.getElementById('closeIcon').classList.remove('hidden');
    document.getElementById('openIcon').classList.add('hidden');

    // Menu is closed remove class to it to trigger slide in transition
    document.getElementById('desktopMenu').classList.add('desktop-open');

    document.getElementById('topNav').classList.add('bg-[#282828]');
    document.getElementById('topNav').classList.remove('hover:md:bg-[#282828]/50');

    // Update the icon logo color when the navigation is open
    document.getElementById('dfLogo').classList.remove('logo-state');
    document.getElementById('dfLogo').classList.add('logo-state-open');

    //document.addEventListener('click', closeMenuOnBodyClick);

}